import { BurstMode, Cancel } from '@mui/icons-material';
import { Box, Button, CircularProgress, styled, Tooltip, Typography } from '@mui/material';
import axios from 'axios';
import { enqueueSnackbar } from 'notistack';
import { useRef, useState } from 'react';
import { UPLOAD_MEDIA } from 'src/services/paths';
import { getMedia } from 'src/utils/getImage';

export const NormalUploader = ({
  error,
  label = 'آپلود تصویر',
  callback = ({ mediaHash }) => {},
  media,
  ratio = '1/1',
}) => {
  const uploaderRef = useRef();
  const [progress, setProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);

  function onCancelUpload() {}
  async function onUpload(files) {
    const media = files[0];
    if (!media) return;
    setIsUploading(true);
    try {
      const body = new FormData();
      body.append('media', media);
      body.append('mediaType', 0);
      const response = await axios.post(UPLOAD_MEDIA, body, {
        timeout: 0,
        onUploadProgress: (e) => {
          const percent = e.progress * 99;
          setProgress(percent);
          if (e.loaded === e.total) {
            setProgress(0);
            setIsUploading(false);
          }
        },
      });

      callback(response.data);
    } catch (error) {
      console.log('Normal Uploader Error', error);
      setProgress(0);
      enqueueSnackbar('خطا در بارگذاری فایل - لطفا مجددا تلاش کنید', { variant: 'error' });
      setIsUploading(false);
    }
  }
  return (
    <>
      <StyledUploaderWrapper sx={{ border: `1px dashed ${error ? '#FF4842' : '#774c9e80'}` }}>
        <Tooltip
          title={
            <Button onClick={onCancelUpload} endIcon={<Cancel color="error" />}>
              <Typography fontSize={14} color="white" sx={{ mx: 1 }}>
                لغو بارگذاری
              </Typography>
            </Button>
          }
          open={isUploading}
          arrow
        >
          {progress > 0 ? (
            <Button size="large" variant="contained" sx={{ width: 150 }}>
              <CircularProgressWithLabel value={progress} size={36} />
            </Button>
          ) : (
            <Button
              variant="contained"
              size="large"
              endIcon={<BurstMode />}
              onClick={() => uploaderRef.current.click()}
            >
              {label}
            </Button>
          )}
        </Tooltip>

        {!!media && (
          <img
            src={!!media && getMedia(media)}
            alt={media}
            style={{ maxWidth: 160, aspectRatio: ratio, objectFit: 'contain' }}
          />
        )}

        <input
          type="file"
          ref={uploaderRef}
          hidden
          accept={'images/*'}
          onChange={(event) => onUpload(event.target.files)}
          onClick={(e) => (e.currentTarget.value = null)}
        />
      </StyledUploaderWrapper>
      {!!error && error !== '' && (
        <Typography variant="caption" color="#FF4842">
          {error}
        </Typography>
      )}
    </>
  );
};

const StyledUploaderWrapper = styled('div')(() => ({
  width: '100%',
  minHeight: 300,
  height: '100%',
  px: 3,
  py: 5,
  borderRadius: '16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  justifyContent: 'center',
  alignItems: 'center',
}));

function CircularProgressWithLabel(props) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress variant="determinate" color="inherit" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" component="div" color="white">
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}
